import { Briefcase } from 'lucide-react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

import { useSelectedUnit } from '../hooks/useSelectedUnit';

/**
 * BU-v2 P3-3 — global operating-unit switcher. Picks the unit new records are
 * created into (the "create into" context). Mirrors BusinessLineSwitcher:
 * self-hides for single-unit tenants (nothing to switch), where the create-edge
 * already routes unambiguously to the one unit.
 */
export function UnitSwitcher() {
  const { units, selectedUnitId, selectUnit } = useSelectedUnit();

  if (units.length <= 1) {
    return null;
  }

  return (
    <Select value={selectedUnitId ?? undefined} onValueChange={selectUnit}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <SelectTrigger
              className="h-9 w-9 justify-center px-0 [&>svg:last-child]:hidden sm:w-[200px] sm:justify-start sm:px-3 sm:[&>svg:last-child]:block"
              aria-label="Switch operating unit"
            >
              <Briefcase className="h-4 w-4 shrink-0 text-muted-foreground sm:mr-1" />
              <span className="hidden min-w-0 sm:inline">
                <SelectValue placeholder="Operating unit" />
              </span>
            </SelectTrigger>
          </TooltipTrigger>
          <TooltipContent>New records are created in this operating unit</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <SelectContent>
        {units.map((unit) => (
          <SelectItem key={unit.id} value={unit.id}>
            {unit.name}
            {unit.isDefault ? ' (default)' : ''}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
